export default __webpack_public_path__ + "static/media/confluence.d11e2f8f.png";